/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { isEmpty } from 'lodash'

import {
  Picklist,
  Spinner
} from '../'

const initialiseOptions = (employees, defaultOption) => {
  let employeesValueIdMapping = {}
  employeesValueIdMapping[defaultOption] = ''

  let employeeIdValuePairs = employees.map(({ node: employee }) => (
    {
      id: employee.identity.id,
      value: `${employee.identity.firstName} ${employee.identity.lastName}`
    }
  ))

  employeeIdValuePairs.forEach((employee) => (
    employeesValueIdMapping[employee.value] = employee.id
  ))

  return { options: employeesValueIdMapping }
}

class EmployeePicklist extends React.PureComponent {
  static getDerivedStateFromProps(props, state) {
    if (isEmpty(state.options) && props.data.employees) {
      return initialiseOptions(props.data.employees.edges, props.default)
    } else {
      return null
    }
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    default: PropTypes.string,
    value: PropTypes.string,
    closeDropdownOnSelect: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    minWidth: PropTypes.number,
    symbol: PropTypes.string,
    inline: PropTypes.bool,
    className: PropTypes.string
  }

  state = {
    options: {}
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Spinner
          className="slds-is-relative"
          size="xx-small"
        />
      )
    }

    if (this.props.data.error) {
      return (
        <div className="slds-text-color_error">
          Failed to load options
        </div>
      )
    }

    let employees = this.state.options
    return (
      <Picklist
        id={this.props.id}
        default={this.props.default}
        options={Object.keys(employees)}
        symbol={this.props.symbol}
        value={this.props.value === ''
           ? "Anyone"
           : Object.keys(employees).find(key => employees[key] === this.props.value)
        }
        onChange={(value) => (
          this.props.onChange(value === ''
            ? value
            : this.state.options[value]
          )
        )}
        closeDropdownOnSelect={this.props.closeDropdownOnSelect}
        inline={this.props.inline}
      />
    )
  }
}

const getEmployees = gql`
  query {
    employees(status: "active", orderBy: "identity__first_name") {
      edges {
        node {
          id
          identity {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

export const withData = graphql(getEmployees)

export default withData(EmployeePicklist)



// WEBPACK FOOTER //
// ./src/components/employee-picklist/index.js